import Vue from "vue";
import VueRouter from "vue-router";

// import store from '@/state/store'
import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: "history",
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);
  const isShow = routeTo.matched.some((route) => route.meta.isShow);
  const isPhilippines = routeTo.matched.some(
    (route) => route.meta.isPhilippines
  );

  document.title = `${process.env.VUE_APP_TITLE} | ${routeTo.name}`;
  const originalTitle = `${process.env.VUE_APP_TITLE} | ${routeTo.name}`;
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
      document.title = "Macrotech USA Inc.";
    } else {
      document.title = originalTitle;
    }
  });

  if (!authRequired) return next();
  const loggedIn = localStorage.getItem("user");
  const user = JSON.parse(loggedIn);
  // Check User is login or not and router is procted or not

  if (authRequired && !loggedIn) {
    next("/login");
  } else {
    // Check is route path is not logut
    if (routeTo.path !== "/logout") {
      if (user && user.user.is_superuser && !isShow) {
        next("/404");
      } else if (user && user.user.is_superuser == undefined && isShow) {
        next("/404");
      } else {
        // Check Condition for add new hotel (Register)

        if (
          user &&
          user.user.is_superuser == undefined &&
          localStorage.hotel == undefined &&
          routeTo.path !== "/hotel-register" &&
          routeTo.path !== "/profile"
        ) {
          next("/hotel-register");
        }
        next();
      }
    } else {
      next();
    }
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

export default router;
